/* eslint-disable no-param-reassign */
import React from 'react';
import { Label, Icon, Image, Popup } from 'semantic-ui-react';
import orderBy from 'lodash/orderBy';
import log from './logger';
export const isDefined = variable => Boolean(variable || variable === 0);
export const getTrailerIdFromVideoClips = videoClips => {
  /**
   * Get trailer youtube id
   */
  if (!videoClips) return null;
  const showTrailer = videoClips ? orderBy(videoClips, ['order'], ['asc'])[0] : null;
  let trailerId = null;
  try {
    trailerId = showTrailer.videoUrl.match(/www.youtube.com\/watch\?v=(.+)$/)[1]; // eslint-disable-line
  } catch (err) {
    null; // eslint-disable-line
  }
  return trailerId;
};

/**
 * Format date to mm/dd/yyyy
 */
export const formatDate = date => date ? date.replace(/(\d\d\d\d)-(\d\d)-(\d\d)(.+)$/, '$2/$3/$1') : date;
/**
 * Format date to mm/dd/yyyy
 */
export const formatDateTime = dateTime => dateTime ? dateTime.replace(/(\d\d\d\d)-(\d\d)-(\d\d).(\d{2}):(\d{2}):(\d{2}).(\d{3}).$/, '$2/$3/$1 $4:$5') : dateTime;

/**
 * Format date to mm/dd/yyyy - considers the ISO date and converts it to local time zone, then formats it
 */
export const formatISODate = isoDate => {
  if (!isoDate) return isoDate;
  const localDate = new Date(isoDate);
  const dateOptions = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  };
  return localDate.toLocaleDateString('en', dateOptions);
};

/**
 * Format date to mm/dd/yyyy
 */
export const formatISODateTime = isoDateTime => {
  if (!isoDateTime) return isoDateTime;
  const datePart = formatISODate(isoDateTime);
  const localDate = new Date(isoDateTime);
  const timeOptions = {
    hour12: false,
    hour: '2-digit',
    minute: '2-digit'
  };
  return "".concat(datePart, " ").concat(localDate.toLocaleTimeString('en', timeOptions));
};

/**
 * Alternate image if src link errors
 */
export const imgError = (image, alternateUrl) => {
  const img = image;
  img.onerror = null;
  if (img.src !== alternateUrl) {
    img.src = alternateUrl;
  }
};
export const getRandomColor = () => {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i += 1) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};
export const formatRatingCount = num => num > 999 ? "".concat((num / 1000).toFixed(1), "k") : num;
export const buildShowTitle = show => {
  let title = show.name;
  if (show.Season) {
    const seriesGroup = (show.Season.SeriesGroup || {}).name;
    const season = show.Season.seasonNumber;
    const episode = show.episodeNumber;
    if (seriesGroup && season && episode) title = "".concat(seriesGroup, " S").concat(season, ":E").concat(episode, " - ").concat(title);
  }
  return title;
  // show &&
  // `
  // ${(((show.Season || '').SeriesGroup || '').name && ' S') || ''}
  // ${((show.Season || '').seasonNumber && ':E') || ''}
  // ${(show.episodeNumber && ' - ') || ''}
  // ${show.name}
  // `
};
export const buildProjectTitle = (project, show, Avatar) => {
  if (show && Avatar) {
    const {
      versionTag,
      publicAccess,
      publishedAt,
      OwnedBy: {
        name,
        avatarUrl
      },
      CertifiedBy
    } = project;
    const isPublic = (publicAccess || 'NO_ACCESS') !== 'NO_ACCESS';
    const isCertified = !!CertifiedBy;
    // eslint-disable-next-line no-nested-ternary
    const avatarImage = avatarUrl ? /*#__PURE__*/React.createElement(Image, {
      avatar: true,
      src: avatarUrl,
      verticalAlign: "middle"
    }) : Avatar ? /*#__PURE__*/React.createElement(Avatar, {
      name: name,
      size: 28,
      round: true
    }) : null;
    const userInfoPopup = /*#__PURE__*/React.createElement(React.Fragment, null, avatarImage, /*#__PURE__*/React.createElement("span", null, '  ', name), /*#__PURE__*/React.createElement("p", {
      style: {
        paddingTop: '10px'
      }
    }, "A ", isCertified ? 'certified' : isPublic ? 'public' : 'private', " project for:", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("b", null, buildShowTitle(show))), publishedAt && /*#__PURE__*/React.createElement("p", null, "Published: ", /*#__PURE__*/React.createElement("b", null, formatISODateTime(publishedAt))));
    return project && /*#__PURE__*/React.createElement(Popup, {
      className: "enjoyPopup",
      trigger: /*#__PURE__*/React.createElement(Label, {
        image: true,
        basic: true
      }, isCertified && /*#__PURE__*/React.createElement(Icon, {
        name: "certificate",
        color: "yellow"
      }), !isCertified && /*#__PURE__*/React.createElement(Icon, {
        name: isPublic ? 'world' : 'privacy',
        color: isPublic ? 'blue' : 'grey'
      }), name, versionTag && /*#__PURE__*/React.createElement(Label.Detail, null, versionTag)),
      hoverable: true,
      content: userInfoPopup
    });
  }
  const {
    versionTag,
    publicAccess,
    OwnedBy: {
      name
    }
  } = project;
  const isPublic = (publicAccess || 'NO_ACCESS') !== 'NO_ACCESS';
  return project && /*#__PURE__*/React.createElement(Label, {
    image: true,
    basic: true
  }, /*#__PURE__*/React.createElement(Icon, {
    name: isPublic ? 'world' : 'privacy',
    color: isPublic ? 'blue' : 'yellow'
  }), name, versionTag && /*#__PURE__*/React.createElement(Label.Detail, null, versionTag));
};
export const simpleResponse = "{\n    ok\n    id\n    errors {\n        path\n        message\n    }\n}";
export const formStatusMessageActive = (type, unsavedChanges, saveSuccess) => {
  let active;
  const saveFail = [null, true].indexOf(saveSuccess) === -1;
  const saved = saveSuccess === true;
  switch (type) {
    case 'info':
      active = !unsavedChanges && !saveFail && !saved;
      break;
    case 'warning':
      active = unsavedChanges && !saveFail;
      break;
    case 'success':
      active = saved;
      break;
    case 'error':
      active = saveFail;
      break;
    default:
      active = false;
  }
  // log.trace(type, active);
  return active;
};

// Determines if the url to the api is fully qualified or should be based on the current client's host
export const deriveApiUrlFromEnv = url => {
  if ((url || '').indexOf('://') > -1) return url;
  const fqurl = "".concat(window.location.protocol, "//").concat(window.location.hostname).concat(url);
  return fqurl;
};
export const valueGradient = _ref => {
  let {
    percent,
    baseMin = 110,
    baseMax = 185,
    defaultHexColor = '949494',
    lowBound = 0,
    highBound = 100,
    repeat = 1
  } = _ref;
  const lowBnd = Math.max(lowBound, 0);
  const highBnd = Math.min(highBound, 100);
  if (!isDefined(percent) || !isDefined(Number(percent)) || Number(percent) < 0 || Number(percent) > 100 || lowBnd > highBnd) {
    return defaultHexColor;
  }
  let percentBase = Number(percent) * repeat % 100;
  percentBase = percentBase * 0.85 + (percentBase > 68 ? 15 : 0); // Cut out some of the ugly yellow-green color

  const nValues = 456;
  const phases = 6;
  const phaseNValues = 76; // (456 / 6)
  const step = 4.56; // (456 / 100)

  const offset = lowBnd / 100 * nValues;
  const scale = (highBnd - lowBnd) / 100;
  const gradientPos = Math.round(percentBase * step * scale + offset);
  const phaseCur = Math.floor(gradientPos / phaseNValues);
  const leftover = gradientPos % phaseNValues;
  const rgb = [(phaseCur + 1) % phases > 2 ? baseMin : baseMax, (phaseCur + 3) % phases > 2 ? baseMin : baseMax, (phaseCur + 5) % phases > 2 ? baseMin : baseMax];
  const midBase = (phaseCur + 2) % 3;
  const midDirection = phaseCur % 2 ? -1 : 1;
  rgb[midBase] += leftover * midDirection;
  const hexColor = rgb.map(dec => dec.toString(16)).join('');
  // log.trace({ percent, percentBase, hexColor, gradientPos });
  return hexColor;
};
export const characterGradient = _ref2 => {
  let {
    char,
    ...rest
  } = _ref2;
  const code = (char || '').toUpperCase().charCodeAt(0);

  /* 'A' code = 65; normalizing to 0.9 will cause red to be included in available colors: */
  const codeBase = code >= 65 && code <= 90 ? code - 64.1 : -1;
  const percent = codeBase / 26 * 100;

  // const percent = (codeBase + (codeBase > 13 ? 4 : 2)) / 30 * 100;

  const hexColor = valueGradient({
    percent,
    ...rest
  });
  // log.trace({ char, code, codeBase, percent, hexColor });
  return hexColor;
};
export const getAvatarUrl = avatarPath => {
  const {
    REACT_APP_AUTH_CLIENT_IMAGE_PATH,
    REACT_APP_AUTH_BASE_URL
  } = process.env;
  if (!avatarPath) {
    return "".concat(REACT_APP_AUTH_CLIENT_IMAGE_PATH, "/avatar-blank.png");
  }
  if (avatarPath.indexOf('://') === -1) {
    return deriveApiUrlFromEnv(REACT_APP_AUTH_BASE_URL + avatarPath);
  }
  return avatarPath;
};

// #d48383: 131, 212
const defaultProfileIconColor = name => '#'.concat(characterGradient({
  char: name,
  baseMin: 131,
  baseMax: 212,
  lowBound: '30',
  repeat: 2
}));
export const getProfileAvatar = _ref3 => {
  let {
    profile,
    className,
    avatarFloat,
    iconSize = 'large',
    newAvatarUrl,
    imgOnError
  } = _ref3;
  return newAvatarUrl || profile.avatarUrl ? /*#__PURE__*/React.createElement(Image, {
    className: 'profile_avatar'.concat(className ? ' '.concat(className) : ''),
    src: newAvatarUrl || getAvatarUrl(profile.avatarUrl),
    floated: avatarFloat,
    circular: true,
    onError: imgOnError
  }) : /*#__PURE__*/React.createElement(Icon, {
    className: 'profile_avatar'.concat(className ? ' '.concat(className) : ''),
    name: profile.name ? undefined : 'user',
    size: iconSize,
    circular: true,
    style: {
      backgroundColor: defaultProfileIconColor(profile.name),
      color: 'white',
      opacity: '1',
      boxShadow: 'rgb(0, 0, 0, 0.18) 0px 0px 0.05em 0.125em inset'
    }
    // color="blue"
    // inverted
  }, (profile.name || '').substr(0, 1).toUpperCase());
};
export const getBrowser = () => {
  let browserName = 'UNKNOWN';
  // Opera 8.0+
  // eslint-disable-next-line no-undef
  if (!!window.opr && !!opr.addons || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0) {
    browserName = 'OPERA';
  }

  // Firefox 1.0+
  if (typeof InstallTrigger !== 'undefined') {
    browserName = 'FIREFOX';
  }

  // Safari 3.0+ "[object HTMLElementConstructor]"
  if (/constructor/i.test(window.HTMLElement) || (p => p.toString() === '[object SafariRemoteNotification]')(
  // eslint-disable-next-line dot-notation,no-undef
  !window['safari'] || typeof safari !== 'undefined' && safari.pushNotification)) {
    browserName = 'SAFARI';
  }

  // Internet Explorer 6-11
  if ( /* @cc_on!@ */false || !!document.documentMode) {
    browserName = 'IE';
  }

  // Edge 20+
  if (browserName !== 'IE' && !!window.StyleMedia) {
    browserName = 'EDGE';
  }

  // Chrome 1 - 71
  if (!!window.chrome && !!window.chrome.runtime && !!window.chrome.runtime.sendMessage // works only on https
  || !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime) || window.location.protocol === 'http:') {
    // assume its supported if this is not an https site (i.e. localhost)
    browserName = 'CHROME';
  }

  // Blink engine detection
  if ((browserName === 'CHROME' || browserName === 'OPERA') && !!window.CSS) {
    browserName = 'BLINK';
  }
  // console.log('browser is', browserName, chrome.runtime);
  return browserName;
};
export const extensionSupportsBrowser = () => ['CHROME', 'OPERA', 'BLINK'].includes(getBrowser());
export const extensionAlreadyInstalled = () => {
  const {
    REACT_APP_ENJOY_EXTENSION_ID
  } = process.env;
  // console.log('sending message to:', REACT_APP_ENJOY_EXTENSION_ID);
  return new Promise(resolve => {
    try {
      if (!REACT_APP_ENJOY_EXTENSION_ID || !((chrome || {}).runtime || {}).sendMessage) {
        resolve(false);
        return;
      }
      chrome.runtime.sendMessage(REACT_APP_ENJOY_EXTENSION_ID, 'version', response => {
        if (chrome.runtime.lastError || !response) {
          // console.log('No extension');
          resolve(false);
          return;
        }
        // console.log('Extension version: ', response.version);
        resolve(response);
      });
    } catch (error) {
      log.trace('swallowing error', error);
      resolve(false);
    }
  });
};
export const handleScroll = (self, callback) => {
  // if (!self.ticking && ((self.topScrolled && window.scrollY > 47) || (!self.topScrolled && window.scrollY <= 47))) {
  if (!self.ticking) {
    // && ((self.topScrolled && window.scrollY > 47) || (!self.topScrolled && window.scrollY <= 47))) {
    window.requestAnimationFrame(() => {
      self.topScrolled = window.scrollY <= 47;
      /** Invoke callback function with self.topScrolled as parameter - not really needed as self
       * is already an input parameter to handleScroll, but may be useful/make more sense when
       * writing the callback function */
      callback(self.topScrolled, window.scrollY);
      self.ticking = false;
    });
    self.ticking = true;
  }
  // if (!self.ticking && self.topScrolled === Boolean(window.scrollY)) {
  //     window.requestAnimationFrame(() => {
  //         self.topScrolled = !window.scrollY;
  //         callback();
  //         // log.trace(self.topScrolled);
  //         self.ticking = false;
  //     });
  //     self.ticking = true;
  // }
  return self.topScrolled; // Not really needed as self is an input parameter, but may be useful
};
let prevVisibilityType;
const queue = [];
export const hookPageVisibility = callback => {
  const checkActive = e => {
    if (prevVisibilityType !== e.type) {
      // reduce double fire issues
      switch (e.type) {
        case 'blur':
          // do work
          // console.log(e.type);
          break;
        case 'focus':
          // do work
          // console.log(e.type);
          callback();
          break;
        default:
        // do nothing
        // console.log(e.type);
      }
    }
    prevVisibilityType = e.type;
  };
  const handleVisibilityChange = () => {
    checkActive({
      type: document.hidden ? 'blur' : 'focus'
    }); // change tab text for demo
  };
  queue.push({
    callback,
    checkActive,
    handleVisibilityChange
  });

  // window.onvisibilitychange = checkActive;
  // window.onblur = checkActive;
  // window.onfocus = checkActive;
  window.addEventListener('blur', checkActive);
  window.addEventListener('focus', checkActive);
  document.addEventListener('visibilitychange', handleVisibilityChange);
};
export const unhookPageVisibility = callback => {
  for (let i = 0; i < queue.length; i += 1) {
    if (queue[i].callback === callback) {
      window.removeEventListener('blur', queue[i].checkActive);
      window.removeEventListener('focus', queue[i].checkActive);
      document.removeEventListener('visibilitychange', queue[i].handleVisibilityChange);
      queue.splice(i, 1);
      break;
    }
  }
};
export const getTabId = () => {
  const {
    REACT_APP_ENJOY_EXTENSION_ID
  } = process.env;
  // console.log('sending message to:', REACT_APP_ENJOY_EXTENSION_ID);
  return new Promise(resolve => {
    if (window.chrome && window.chrome.runtime) {
      window.chrome.runtime.sendMessage(REACT_APP_ENJOY_EXTENSION_ID, 'getTabId', response => {
        if (!response) {
          // console.log('No extension');
          resolve(null);
          return;
        }
        // console.log('Extension version: ', response.version);
        resolve(response);
      });
    } else {
      resolve(null);
    }
  });
};
export const handleFocusStolen = e => {
  /* Check if Netflix has stolen focus. Add other possible focus thieves as necessary */
  // const focusStolen = (((e.relatedTarget || {}).className || '').match(/nf-player-container|active/g) || []).length === 2
  const thiefClassName = (e.relatedTarget || {}).className || '';
  const huluFocusThief = thiefClassName.match(/L2Content addFocus/);
  const focusStolen = thiefClassName.match(/nf-player-container/) && !e.sourceCapabilities || e.relatedTarget && e.relatedTarget.getAttribute('data-uia') === 'player' || huluFocusThief;
  if (focusStolen) {
    if (huluFocusThief) e.relatedTarget.style.display = 'none'; // Causes infinite loop if display is not set to none
    log.trace('Returning focus! e:', e);
    e.target.focus();
  }
};
const handlers = [];
export const addHandler = _ref4 => {
  let {
    listeners,
    getElement,
    componentHandlers,
    defaultFocused
  } = _ref4;
  let loopCap = 240;
  (function tryAddHandler() {
    // log.trace('attempting to get element: ', element, getElement(), loopCap);
    const element = getElement(); // eslint-disable-line no-param-reassign
    if (element) {
      listeners.forEach(listener => {
        element[listener.event] = listener.callback; // eslint-disable-line no-param-reassign
        handlers.push({
          element,
          event: listener.event
        });
        /* If componentHandlers list provided, push to it as well to be able to remove just those handlers on component unmount */
        if (componentHandlers) componentHandlers.push({
          element,
          event: listener.event,
          i: handlers.length - 1
        });
        if (defaultFocused) element.focus();
        // log.trace('handlers:', handlers);
      });
    } else if (loopCap > 0 /* && self.mounted */) {
      loopCap -= 1;
      setTimeout(tryAddHandler, 250);
    } else {
      log.warn('element not found! getElement:', getElement);
    }
  })();
};
export const removeHandlers = componentHandlers => {
  /* If componentHandlers provided, only remove handlers from that list instead of all handlers */
  // log.trace('*************************** REMOVING EVENT HANDLERS (componentHandlers = ', componentHandlers, ') ***************************');
  const handlerList = componentHandlers || handlers;
  for (let index = handlerList.length - 1; index >= 0; index -= 1) {
    const handler = handlerList[index];
    handler.element[handler.event] = null;
    handlerList.splice(index, 1);
    if (componentHandlers) handlers.splice(handler.i, 1);
  }
};
let focusedInputValue;
const handleOnFocus = e => {
  focusedInputValue = e.target.value;
};
export const forceNumericValue = e => {
  const {
    value
  } = e.target;
  if (!Number.isNaN(Number(value)) && Boolean(value.match('^[0-9.]*$'))) focusedInputValue = value;else e.target.value = focusedInputValue;
};
export const addInputCoreHandlers = _ref5 => {
  let {
    getElement,
    componentHandlers,
    forceNumeric,
    defaultFocused
  } = _ref5;
  addHandler({
    listeners: [{
      event: 'onclick',
      callback: e => e.target.focus()
    }, {
      event: 'onfocus',
      callback: handleOnFocus
    }, {
      event: 'onblur',
      callback: handleFocusStolen
    }, {
      event: 'onkeydown',
      callback: e => {
        if (forceNumeric) forceNumericValue(e);
        e.stopPropagation(); // To allow typing into text box
      }
    }, {
      event: 'onkeyup',
      callback: e => {
        if (forceNumeric) forceNumericValue(e);
        e.stopPropagation(); // To prevent shortcut keys when typing
      }
    }],
    getElement,
    componentHandlers,
    defaultFocused
  });
};
export const pinRestrictedRatings = [{
  text: null,
  code: 'ALL',
  groupCodes: 'NONE',
  allowedCodes: 'NONE',
  description: /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, "All"), " content is protected by PIN.")
}, {
  text: 'Tiny Ones',
  code: 'G|TV-Y|TV-G',
  groupCodes: 'G|TV-Y|TV-G',
  allowedCodes: 'G|TV-Y|TV-G',
  description: /*#__PURE__*/React.createElement("span", null, "Content for ", /*#__PURE__*/React.createElement("b", null, "Older Kids"), " and up will require the PIN to start playback.")
}, {
  text: 'Older Kids',
  code: 'PG|TV-Y7|TV-Y7-FV|TV-PG',
  groupCodes: 'PG|TV-Y7|TV-Y7-FV|TV-PG',
  allowedCodes: 'G|TV-Y|TV-G|PG|TV-Y7|TV-Y7-FV|TV-PG',
  description: /*#__PURE__*/React.createElement("span", null, "Content for ", /*#__PURE__*/React.createElement("b", null, "Teens"), " and up will require the PIN to start playback.")
}, {
  text: 'Teens',
  code: 'PG-13|TV-14',
  groupCodes: 'PG-13|TV-14|16+',
  allowedCodes: 'G|TV-Y|TV-G|PG|TV-Y7|TV-Y7-FV|TV-PG|PG-13|TV-14|16+',
  description: /*#__PURE__*/React.createElement("span", null, "Content for ", /*#__PURE__*/React.createElement("b", null, "Adults"), " protected by PIN.")
}, {
  text: 'Adults',
  code: 'R|TV-MA|NC-17|NR|UR',
  groupCodes: 'R|TV-MA|NC-17|NR|UR',
  allowedCodes: 'ALL',
  description: /*#__PURE__*/React.createElement("span", null, "PIN protection is ", /*#__PURE__*/React.createElement("b", null, "off"), ". All content will be available without a PIN.")
}, {
  text: null,
  code: 'NONE',
  groupCodes: 'ALL',
  allowedCodes: 'ALL',
  description: /*#__PURE__*/React.createElement("span", null, "PIN protection is ", /*#__PURE__*/React.createElement("b", null, "off"), ". All content will be available without a PIN.")
}];
export const setLocalStorageWithExpiry = (key, value, ttl) => {
  const now = new Date();
  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire
  const item = {
    value,
    expiry: now.getTime() + ttl
  };
  localStorage.setItem(key, JSON.stringify(item));
};
export const getLocalStorageWithExpiry = key => {
  const itemStr = localStorage.getItem(key);
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
};